import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect, useState, createContext, useContext } from "react";
import { LoadingPage } from "./LoadingPage";
import Cookies from 'js-cookie';

// Create a context
const AppMetadataContext = createContext(null);

export const Auth0MetaData = ( { children }: { children: React.ReactNode } ) =>
{
	const { isLoading, isAuthenticated, getIdTokenClaims, getAccessTokenSilently } = useAuth0();
	const [ loading, setLoading ] = useState( true );
	const [ appMetadata, setAppMetadata ] = useState( null );
	const K_APP_META_DATA = "https://fipok.com/app_metadata";
	const K_ACCESS_TOKEN_COOKIE = "auth_token";
	useEffect(
		() =>
		{
			const fetchData =
				async () => 
				{
					try {
						const token = await getAccessTokenSilently();
						// Set cookie with the token
						Cookies.set(
							K_ACCESS_TOKEN_COOKIE,
							token,
							{ 
								expires: 1, // Expires in 1 day
								secure: true, // For HTTPS
								sameSite: 'Lax', // CSRF protection
								domain: '.fipok.com' // Replace with your domain
							} );
					} catch ( error ) {
						console.error( "Error setting authentication cookie", error );
					}
					try {
						const idTokenClaims = await getIdTokenClaims();
						if ( idTokenClaims !== undefined && K_APP_META_DATA in idTokenClaims ) {
							setAppMetadata( idTokenClaims[ K_APP_META_DATA ] );
						}
						setLoading( false );
					} catch ( error ) {
						// TODO: Handle error
						console.log( `Auth0MetaData::useEffect() error getting/decoding idToken: '${error}` );
					}
				};

			if ( loading && isAuthenticated ) {
				fetchData();
			}
		},
		[
			loading,
			getIdTokenClaims,
			getAccessTokenSilently,
			isAuthenticated
		] );
	if ( isLoading && loading ) {
		// TODO: work this out
		return (
			<LoadingPage/>
		)
	}

	return (
		<AppMetadataContext.Provider value={appMetadata}>
			{children}
		</AppMetadataContext.Provider>
	);
};

// Custom hook to access the appMetadata value
export const useAppMetadata = () => useContext(AppMetadataContext);